import React from "react";
// @material-ui/core components
import { useTheme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import Grid from "@material-ui/core/Grid";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Typography from "@material-ui/core/Typography";
// @material-ui/icons components
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import ArrowUpward from "@material-ui/icons/ArrowUpward";

// core components
import boxShadows from "assets/theme/box-shadow.js";

function CardPageVisits() {
  const theme = useTheme();
  return (
    <>
      <Card
        sx={{
          boxShadow: boxShadows.boxShadow + "!important",
          border: "0!important",
        }}
      >
        <CardHeader
          subheader={
            <Grid
              container
              component={Box}
              sx={{ alignItems: "center", justifyContent: "space-between" }}
            >
              <Grid item xs="auto">
                <Box
                  component={Typography}
                  variant="h3"
                  sx={{ marginBottom: "0!important" }}
                >
                  Page visits
                </Box>
              </Grid>
              <Grid item xs="auto">
                <Box
                  sx={{
                    justifyContent: "flex-end",
                    display: "flex",
                    flexWrap: "wrap",
                  }}
                >
                  <Button variant="contained" color="primary" size="small">
                    See all
                  </Button>
                </Box>
              </Grid>
            </Grid>
          }
          sx={{ backgroundColor: "initial!important" }}
        ></CardHeader>
        <TableContainer>
          <Box
            component={Table}
            sx={{ alignItems: "center", marginBottom: "0!important" }}
          >
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{
                    verticalAlign: "middle",
                    paddingLeft: "1.5rem",
                    paddingRight: "1.5rem",
                    borderTop: "0",
                    backgroundColor: theme.palette.gray[100],
                    color: theme.palette.gray[600],
                    fontSize: ".65rem",
                  }}
                >
                  Page name
                </TableCell>
                <TableCell
                  sx={{
                    verticalAlign: "middle",
                    paddingLeft: "1.5rem",
                    paddingRight: "1.5rem",
                    borderTop: "0",
                    backgroundColor: theme.palette.gray[100],
                    color: theme.palette.gray[600],
                    fontSize: ".65rem",
                  }}
                >
                  Visitors
                </TableCell>
                <TableCell
                  sx={{
                    verticalAlign: "middle",
                    paddingLeft: "1.5rem",
                    paddingRight: "1.5rem",
                    borderTop: "0",
                    backgroundColor: theme.palette.gray[100],
                    color: theme.palette.gray[600],
                    fontSize: ".65rem",
                  }}
                >
                  Unique users
                </TableCell>
                <TableCell
                  sx={{
                    verticalAlign: "middle",
                    paddingLeft: "1.5rem",
                    paddingRight: "1.5rem",
                    borderTop: "0",
                    backgroundColor: theme.palette.gray[100],
                    color: theme.palette.gray[600],
                    fontSize: ".65rem",
                  }}
                >
                  Bounce rate
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell
                  sx={{
                    verticalAlign: "middle",
                    paddingLeft: "1.5rem",
                    paddingRight: "1.5rem",
                    borderTop: "0",
                    textTransform: "unset!important",
                    fontSize: ".8125rem",
                  }}
                  component="th"
                  variant="head"
                  scope="row"
                >
                  /argon/
                </TableCell>
                <TableCell
                  sx={{
                    verticalAlign: "middle",
                    paddingLeft: "1.5rem",
                    paddingRight: "1.5rem",
                    borderTop: "0",
                  }}
                >
                  4,569
                </TableCell>
                <TableCell
                  sx={{
                    verticalAlign: "middle",
                    paddingLeft: "1.5rem",
                    paddingRight: "1.5rem",
                    borderTop: "0",
                  }}
                >
                  340
                </TableCell>
                <Box
                  component={TableCell}
                  sx={{
                    verticalAlign: "middle",
                    paddingLeft: "1.5rem",
                    paddingRight: "1.5rem",
                    borderTop: "0",
                    marginBottom: "-2px",
                  }}
                >
                  <Box
                    component={ArrowUpward}
                    sx={{
                      width: "1rem!important",
                      height: "1rem!important",
                      marginRight: "1rem",
                      color: theme.palette.success.main,
                    }}
                  />
                  46,53%
                </Box>
              </TableRow>
              <TableRow>
                <TableCell
                  sx={{
                    verticalAlign: "middle",
                    paddingLeft: "1.5rem",
                    paddingRight: "1.5rem",
                    borderTop: "0",
                    textTransform: "unset!important",
                    fontSize: ".8125rem",
                  }}
                  component="th"
                  variant="head"
                  scope="row"
                >
                  /argon/index.html
                </TableCell>
                <TableCell
                  sx={{
                    verticalAlign: "middle",
                    paddingLeft: "1.5rem",
                    paddingRight: "1.5rem",
                    borderTop: "0",
                  }}
                >
                  3,985
                </TableCell>
                <TableCell
                  sx={{
                    verticalAlign: "middle",
                    paddingLeft: "1.5rem",
                    paddingRight: "1.5rem",
                    borderTop: "0",
                  }}
                >
                  319
                </TableCell>
                <Box
                  component={TableCell}
                  sx={{
                    verticalAlign: "middle",
                    paddingLeft: "1.5rem",
                    paddingRight: "1.5rem",
                    borderTop: "0",
                    marginBottom: "-2px",
                  }}
                >
                  <Box
                    component={ArrowDownward}
                    sx={{
                      width: "1rem!important",
                      height: "1rem!important",
                      marginRight: "1rem",
                      color: theme.palette.warning.main,
                    }}
                  />
                  46,53%
                </Box>
              </TableRow>
              <TableRow>
                <TableCell
                  sx={{
                    verticalAlign: "middle",
                    paddingLeft: "1.5rem",
                    paddingRight: "1.5rem",
                    borderTop: "0",
                    textTransform: "unset!important",
                    fontSize: ".8125rem",
                  }}
                  component="th"
                  variant="head"
                  scope="row"
                >
                  /argon/charts.html
                </TableCell>
                <TableCell
                  sx={{
                    verticalAlign: "middle",
                    paddingLeft: "1.5rem",
                    paddingRight: "1.5rem",
                    borderTop: "0",
                  }}
                >
                  3,513
                </TableCell>
                <TableCell
                  sx={{
                    verticalAlign: "middle",
                    paddingLeft: "1.5rem",
                    paddingRight: "1.5rem",
                    borderTop: "0",
                  }}
                >
                  294
                </TableCell>
                <Box
                  component={TableCell}
                  sx={{
                    verticalAlign: "middle",
                    paddingLeft: "1.5rem",
                    paddingRight: "1.5rem",
                    borderTop: "0",
                    marginBottom: "-2px",
                  }}
                >
                  <Box
                    component={ArrowDownward}
                    sx={{
                      width: "1rem!important",
                      height: "1rem!important",
                      marginRight: "1rem",
                      color: theme.palette.warning.main,
                    }}
                  />
                  36,49%
                </Box>
              </TableRow>
              <TableRow>
                <TableCell
                  sx={{
                    verticalAlign: "middle",
                    paddingLeft: "1.5rem",
                    paddingRight: "1.5rem",
                    borderTop: "0",
                    textTransform: "unset!important",
                    fontSize: ".8125rem",
                  }}
                  component="th"
                  variant="head"
                  scope="row"
                >
                  /argon/tables.html
                </TableCell>
                <TableCell
                  sx={{
                    verticalAlign: "middle",
                    paddingLeft: "1.5rem",
                    paddingRight: "1.5rem",
                    borderTop: "0",
                  }}
                >
                  2,050
                </TableCell>
                <TableCell
                  sx={{
                    verticalAlign: "middle",
                    paddingLeft: "1.5rem",
                    paddingRight: "1.5rem",
                    borderTop: "0",
                  }}
                >
                  147
                </TableCell>
                <Box
                  component={TableCell}
                  sx={{
                    verticalAlign: "middle",
                    paddingLeft: "1.5rem",
                    paddingRight: "1.5rem",
                    borderTop: "0",
                    marginBottom: "-2px",
                  }}
                >
                  <Box
                    component={ArrowUpward}
                    sx={{
                      width: "1rem!important",
                      height: "1rem!important",
                      marginRight: "1rem",
                      color: theme.palette.success.main,
                    }}
                  />
                  50,87%
                </Box>
              </TableRow>
              <TableRow>
                <TableCell
                  sx={{
                    verticalAlign: "middle",
                    paddingLeft: "1.5rem",
                    paddingRight: "1.5rem",
                    borderTop: "0",
                    textTransform: "unset!important",
                    fontSize: ".8125rem",
                    borderBottom: "0!important",
                  }}
                  component="th"
                  variant="head"
                  scope="row"
                >
                  /argon/profile.html
                </TableCell>
                <TableCell
                  sx={{
                    verticalAlign: "middle",
                    paddingLeft: "1.5rem",
                    paddingRight: "1.5rem",
                    borderTop: "0",
                    borderBottom: "0!important",
                  }}
                >
                  1,795
                </TableCell>
                <TableCell
                  sx={{
                    verticalAlign: "middle",
                    paddingLeft: "1.5rem",
                    paddingRight: "1.5rem",
                    borderTop: "0",
                    borderBottom: "0!important",
                  }}
                >
                  190
                </TableCell>
                <Box
                  component={TableCell}
                  sx={{
                    verticalAlign: "middle",
                    paddingLeft: "1.5rem",
                    paddingRight: "1.5rem",
                    borderTop: "0",
                    borderBottom: "0!important",
                    marginBottom: "-2px",
                  }}
                >
                  <Box
                    component={ArrowDownward}
                    sx={{
                      width: "1rem!important",
                      height: "1rem!important",
                      marginRight: "1rem",
                      color: theme.palette.error.main,
                    }}
                  />
                  46,53%
                </Box>
              </TableRow>
            </TableBody>
          </Box>
        </TableContainer>
      </Card>
    </>
  );
}

export default CardPageVisits;
